const Tool_2_PanelComponent = ({ mapView }) => {

    return (
        <>
            <p>Some contents Tool_2_PanelComponent...</p>
            <p>Some contents Tool_2_PanelComponent...</p>
            <p>Some contents Tool_2_PanelComponent...</p>
        </>
    )
};
export default Tool_2_PanelComponent;